import React, { Suspense } from 'react';
import Helmet from 'react-helmet';
import { ServerErrorLayout } from '@layouts';
import { homeUrl, priceListUrl } from '@urls';

const NotFoundSvg = React.lazy(() =>
  import('assets/not-found.svg?react').then((m) => ({ default: m.default })),
);

export const NotFoundView: React.FC = () => (
  <>
    <Helmet
      title="404 - Nie znaleziono strony | Praca na Kolach"
      meta={[
        { name: 'prerender-status-code', content: '404' },
        { name: 'robots', content: 'noindex, follow' },
      ]}
    />
    <div id="__PNK_404__" style={{ display: 'none' }} />
    <ServerErrorLayout
      image={
        <Suspense fallback={null}>
          <NotFoundSvg />
        </Suspense>
      }
      headerText="Nie można odnaleźć strony www bądź pliku."
      subHeaderText={
        <>
          Strona, której szukasz jest niedostępna.
          <br />
          Spróbuj ponownie lub wróć do strony głównej.
        </>
      }
      backPath={homeUrl}
      backText="Strona główna"
      secondaryBackPath={priceListUrl}
      secondaryBackText="Cennik"
    />
  </>
);
